
import { makeStyles } from 'tss-react/mui';
import EDIcon from '../../BaseComponents/Icon/EDIcon';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDFab from '../../BaseComponents/Fab/EDFab';
import EDTooltip from '../../BaseComponents/Tooltip/EDTooltip';

interface IProps {
  display: boolean;
  updateActive: boolean;
  updateTooltip?: string;
  update: (updateOrig?: boolean) => void;
  handleTabSelection?: (newValue: number) => void;
}

const useStyles = makeStyles()(theme => ({
  overlayContainer: {
    display: 'flex',
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 72px)',
    zIndex: 1200,
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between',
  },
  textContainer: {
    textAlign: 'center',
    marginTop: 4,
  },
}));

/**
 * En uppdateringsknapp som läggs ovanpå övrigt innehåll för ett tydligt uppdateringsläge.
 */
const UpdateOverlay: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes, cx } = useStyles(undefined, {
    props: props as any,
  });
  if (!props.display) {
    return null;
  }

  const onUpdateAnalysClick = () => {
    if (props.handleTabSelection) {
      props.handleTabSelection(0);
    }
    props.update(undefined);
  };

  return (
    <div className={classes.overlayContainer}>
      <div className={classes.flexContainer}>
        <EDTooltip title={props.updateTooltip}>
          <span>
            <EDFab
              size="large"
              marginY={0}
              marginX={3}
              disabled={!props.updateActive}
              onClick={onUpdateAnalysClick}
              color="primary"
              boxShadowNone
              disabledButtonStyle
            >
              <EDIcon
                iconType="refresh"
                size="large"
                color={props.updateActive ? 'white' : 'lowEmphasis'}
              />
            </EDFab>
          </span>
        </EDTooltip>
        <div className={cx(classes.textContainer)}>
          <EDTypography underlined color="primary" component="span">
            A
          </EDTypography>
          <EDTypography component="span" color="primary">
            nalysera
          </EDTypography>
        </div>
      </div>
    </div>
  );
};

export default UpdateOverlay;
